export enum SessionParticipantType {
  SELF, HOST, PARTICIPANT, FAKE
}

export abstract class SessionParticipant {
  abstract name: string
  abstract teacher: boolean
  abstract userId: string | number
  abstract utishaUserId: number | undefined
  abstract type: SessionParticipantType
  abstract videoOn: boolean
  abstract activeSpeaker: boolean
  abstract muted: boolean
  abstract options?: { [key: string]: string}
  abstract useSelfVideo: boolean;
  abstract data?: any;

  isSelf(): boolean {
    return this.type === SessionParticipantType.SELF
  }

  equals(other: SessionParticipant): boolean {
    return this.userId === other.userId &&
      this.videoOn === other.videoOn &&
      this.name === other.name &&
      this.muted === other.muted
  }

  videoHashKey(): string {
    return `${this.userId}-${this.videoOn ? '1' : '0'}`;
  }

  audioHashKey(): string {
    return `${this.userId}-${this.muted ? '1' : '0'}`;
  }

  videoOrAudioHashKey(): string {
    return `${this.userId}-${this.videoOn ? '1' : '0'}-${this.muted ? '1' : '0'}`;
  }

  toString() {
    return `${this.name} (${this.utishaUserId} / ${this.userId}) - Video ${this.videoOn ? 'on':'off'}`
  }
}

export type SessionParticipantEventHandler = (p: SessionParticipant) => void
